import {
  Flex, CardProps,
} from "@chakra-ui/react";
import { titleize } from "helpers/string";
import { Integration, getIntegrationLogoUrl } from "models/integration";
import { useIntegrationListQuery } from "features/Integrations/hooks";
import IntegrationSection from "./IntegrationSection";
import IntegrationCard from "./IntegrationCard";

export default function ConnectedIntegrations({ ...rest }: CardProps) {
  const { data: integrations } = useIntegrationListQuery({
    placeholderData: [],
  });

  return (
    <IntegrationSection title="Connected" isLoaded={!!integrations} {...rest}>
      <Flex direction="row" gap="4" wrap="wrap">
        {(integrations || []).map((integration: Integration) => (
          <IntegrationCard
            key={integration.id}
            id={integration.id}
            name={titleize(integration.partner)}
            partner={integration.partner}
            description={integration.description}
            logoUrl={getIntegrationLogoUrl(integration.partner)}
            isActive={integration.isActive}
            isConnected
            includeDelete
            pauseable={!["slack", "google_calendar", "zoom"].includes(integration.partner)}
            createdAt={integration.createdAt}
            updatedAt={integration.updatedAt}
            messageService={integration.messageService}
          />
        ))}
      </Flex>
    </IntegrationSection>
  );
}
